import { ErrorDescription } from '../apiResult/interfaces';
import { notify } from './notify';

export const showErrorNotification = (error?: ErrorDescription) => {
    notify({
        type: 'danger',
        message: error ? error.message : 'Ups, Something went wrong',
    });
};
